import { CustomInput } from '../../CustomInput';
import { useIntl } from 'react-intl';

export const BasicFieldInputs = ({
  fields,
  fieldValues,
  requiredFields = [],
  onChange,
}: {
  fields: string[];
  fieldValues: any;
  requiredFields?: string[];
  onChange: (key: string, value: string) => void;
}) => {
  const intl = useIntl();
  return (
    <>
      {fields.map((key) => (
        <CustomInput
          key={key}
          type="text"
          value={fieldValues?.[key] || ''}
          isRequired={requiredFields.includes(key)}
          name={key}
          label={intl.formatMessage({ id: key })}
          onChange={(value) => onChange(key, value)}
        />
      ))}
    </>
  );
};
